import apps from './apps'
import versions from './versions'
import intents from './intents'
import entities from './entities'
export default {
  state: {
    navigate: {
      activeSection: 'apps'
    },
    ...apps.state,
    ...versions.state,
    ...intents.state,
    ...entities.state,
  },
  getters: {
    ...apps.getters,
    ...versions.getters,
    ...intents.getters,
    ...entities.getters,
  },
  mutations: {
    ...apps.mutations,
    ...versions.mutations,
    ...intents.mutations,
    ...entities.mutations,
  },
  actions: {
    ...apps.actions,
    ...versions.actions,
    ...intents.actions,
    ...entities.actions,
  }
}
